import login from './login';
import config from './config';
export default {
	login,
	config
}